<template>
  <div class="common-footer">
    <div class="logo_block">
      <div class="double-flex">
        <!-- <ShadowButton
          class="shadow-button pc"
          text="About us"
          @handleShadowBtnClick="goToAboutUs"
        /> -->
        <ShadowButton
          class="shadow-button pc"
          text="Specified Commercial Transaction Law"
          @handleShadowBtnClick="goToSpecificCommerce"
        />
        <ShadowButton
          class="shadow-button"
          text="Terms of service"
          @handleShadowBtnClick="goToTermsOfService"
        />
        <ShadowButton
          class="shadow-button pc"
          text="Privacy Statement"
          @handleShadowBtnClick="goToPrivacyProtection"
        />
        <ShadowButton
          class="shadow-button"
          text="User Guide"
          @handleShadowBtnClick="goToUserGuide"
        />
        <ShadowButton
          class="shadow-button"
          text="Contact us"
          @handleShadowBtnClick="goContactUs"
        />
      </div>
      <div class="logo">
        <img src="/img/logo_type2.png">
        <div>Copyright © 2021 iranoan All rights reserved.</div>
      </div>
    </div>
  </div>
</template>

<script>
// import DoubleBorderBox from '@/components/molecules/DoubleBorderBox.vue';
import ShadowButton from '@/components/molecules/ShadowButton.vue';
import t from '@/plugins/i18n';

export default {
  name: 'CommonFooter',

  components: {
    // DoubleBorderBox,
    ShadowButton,
  },

  props: {
    currentUser: {
      type: Object,
    },
  },
  mixins: [t],

  methods: {
    goToLogin() {
      // ログインしていない場合、ログイン画面へ。routerのbeforeEachだとエラーが出る。（リダイレクトはされる）
      const query = {
        packId: this.$route.query.packId,
      };
      this.$router.push({
        path: '/login',
        query: this.$route.query.packId ? query : null,
      });
    },
    goToTop() {
      if (this.$route.name === 'Top') {
        return;
      }
      this.$router.push('/');
    },
    goToMyPage() {
      if (this.$route.name === 'MyPage') {
        return;
      }
      if (this.currentUser.is_login === '0') {
        if (this.$route.name === 'UserLogin') {
          return;
        }
        this.goToLogin();
        return;
      }
      this.$router.push('/my-page');
    },
    goToBuyPoint() {
      if (this.$route.name === 'BuyPoint') {
        return;
      }
      if (this.currentUser.is_login === '0') {
        if (this.$route.name === 'UserLogin') {
          return;
        }
        this.goToLogin();
        return;
      }
      let url = '/buy-point';
      if (this.$route.params.productId) {
        url += `/${this.$route.params.productId}`;
      }
      this.$router.push(url);
    },
    goToBuyProductHistory() {
      if (this.$route.name === 'BuyProductHistory') {
        return;
      }
      if (this.currentUser.is_login === '0') {
        if (this.$route.name === 'UserLogin') {
          return;
        }
        this.goToLogin();
        return;
      }
      this.$router.push('/buy-product-history');
    },
    goToSpecificCommerce() {
      this.$router.push('/specific-commerce');
    },
    goToTermsOfService() {
      this.$router.push('/terms-of-service');
    },
    goToPrivacyProtection() {
      this.$router.push('/privacy-protection');
    },
    goToUserGuide() {
      this.$router.push('/user-guide');
    },
    goContactUs() {
      window.open('https://minny-online-store.iranoan.com/contacts?service=1', '_blank');
    },
    goToAboutUs() {
      window.open('https://iranoan.site/', '_blank');
    },
  },
};
</script>

<style lang="scss" scoped>
.common-footer {
  background-color: #081b40;
  position: absolute;
  bottom: 0;
  width: 100vw;
  .double-flex {
    padding: 20px;
    .shadow-button {
      margin: 5px 15px;
    }
  }
  .footer-button-area {
    display: none;
  }
  .logo_block {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    width: 100%;
    max-width: 1000px;
    margin: auto;
    .logo {
      padding: 20px;
      text-align: right;
      color: $white;
      img {
        width: 160px;
      }
      div {
        font-size: 12px;
      }
    }
  }
}
.footer {
  background-color: $mainColor;
  color: #fff;
  text-align: center;
  font-size: 12px;
  padding: 0 0 20px 0;
}
.pc {
  display: block;
}
.sp {
  display: none;
}
@media screen and (max-width: $tabletWidth) {
  .common-footer{
    .double-flex {
      padding: 20px 20px;
      .shadow-button {
        width: 100%;
        margin: 10px 0;
      }
    }
    .logo_block {
      flex-direction: column;
      align-items: flex-start;
      .logo {
        width: 100%;
        padding: 0 0 20px 0;
        position: relative;
        img {
          position: absolute;
          bottom: 50px;
          right: 30px;
          width: 160px;
        }
        div {
          text-align: center;
        }
      }
    }
  }
}
</style>
